export type ValueItem = {
  icon: string;
  title: string;
  description: string;
};

type AboutValuesProps = {
  values: ValueItem[];
};

export default function AboutValues({ values }: AboutValuesProps) {
  return (
    <section className="py-20 lg:py-32 bg-[#F8FAFC]" id="values">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-[43px] font-medium text-[#010305] mb-2">Our Core Values</h2>
          <p className="text-lg text-[#677078] max-w-3xl mx-auto">
            The principles that guide every decision and action across our organization
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white p-8 rounded-xl transition-all cursor-pointer" style={{ boxShadow: '0px 10px 15px -3px #00000014, 0px 4px 6px -4px #00000014' }}>
              <div className="w-[56px] h-[56px] bg-[#E4F1FF] rounded-full flex items-center justify-center mb-6">
                <i className={`${value.icon} text-2xl text-[#00458F]`}></i>
              </div>
              <h3 className="text-xl font-medium text-[#0F172A] mb-4">{value.title}</h3>
              <p className="text-[#4B5563] leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
